var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-content" },
    [
      _c("el-cascader", {
        ref: "cascaders",
        staticClass: "custome-popper-class",
        attrs: {
          placeholder: "请输入或选择行政区",
          props: _vm.props,
          options: _vm.regionList,
          filterable: ""
        },
        on: { change: _vm.handleCasChange },
        model: {
          value: _vm.place,
          callback: function($$v) {
            _vm.place = $$v
          },
          expression: "place"
        }
      }),
      _c("dt", { staticClass: "cascader-dt" }, [_vm._v("中国城市列表")]),
      _c(
        "div",
        { staticClass: "region-div" },
        _vm._l(_vm.regionList, function(item, index) {
          return _c(
            "dl",
            {
              key: index,
              class: [
                "search-list",
                {
                  "is-active": _vm.regionActiveId === item.regionId
                }
              ]
            },
            [
              _c("dt", { staticClass: "parent-region region-disabled" }, [
                _vm._v(_vm._s(item.regionName))
              ]),
              _c(
                "dd",
                _vm._l(item.children, function(city, index) {
                  return _c(
                    "ul",
                    {
                      key: index,
                      on: {
                        click: function($event) {
                          _vm.$store.state.user.limitRegionType < 3
                            ? _vm.handleRegionClick(city, 2)
                            : () => {}
                        }
                      }
                    },
                    [
                      _c(
                        "li",
                        {
                          class: [
                            {
                              "is-active": _vm.regionActiveId === city.regionId
                            },
                            _vm.$store.state.user.limitRegionType < 3
                              ? "parent-region"
                              : "parent-region region-disabled"
                          ]
                        },
                        [_vm._v(" " + _vm._s(city.regionName) + " ")]
                      ),
                      _vm._l(city.children, function(con, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            class: [
                              {
                                "is-active": _vm.regionActiveId === con.regionId
                              }
                            ],
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.handleRegionClick(con, 3)
                              }
                            }
                          },
                          [_vm._v(" " + _vm._s(con.regionName) + " ")]
                        )
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }